import { render, staticRenderFns } from "./LegalDocumentContent_nBgJKe.vue?vue&type=template&id=7a1aa878&scoped=true&"
var script = {}
import style0 from "./LegalDocumentContent_nBgJKe.vue?vue&type=style&index=0&id=7a1aa878&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1aa878",
  null
  
)

export default component.exports